import React, { useState } from 'react';
import './Contact.scss';
import { SlArrowDownCircle, SlArrowUpCircle } from "react-icons/sl";
import { useNavigate } from 'react-router-dom';

function ContactCard({ baseData }) {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();
    
    return (
        <>
            <div className='d-flex align-items-start flex-column'>
                <div className='contactCard m-4 mb-0 pb-1' style={{ position: 'relative' }}>
                    <div className='teamName' style={{cursor: 'pointer'}} onClick={ ()=> navigate('/processHub', { state: { initialData: baseData } }) }>{baseData.department}</div>
                    <div className='teamSpoc'>{baseData.spoc}</div>
                    {baseData?.spocemail && <div className='teamMail' title={baseData?.spocemail}>{baseData?.spocemail}</div>}
                    {baseData?.subDepartments?.length > 0 && (
                        <div className='pt-1' style={{ position: 'absolute', bottom: '16px', cursor: 'pointer' }}>
                            {expanded ? (
                                <SlArrowUpCircle size={30} onClick={() => setExpanded(false)} title='Collapse' />
                            ) : (
                                <SlArrowDownCircle size={30} onClick={() => setExpanded(true)} title='Expand' />
                            )}
                        </div>
                    )}
                </div>
                {expanded && baseData.subDepartments.map(sub => (
                    <ContactCard key={sub.id} baseData={sub} />
                ))}
            </div>
        </>
    );
}

export default ContactCard;